import React, { useState, useEffect } from 'react'
import { Line } from 'react-chartjs-2'
import numeral from 'numeral'


const options = {
  legend: {
    display: false,
  },
  elements: {
    point: {
      radius: 0,
    },
  },
  maintainAspectRatio: false,
  tooltips: {
    mode: "index",
    intersect: false,
    callbacks: {
      label: function (tooltipItem, data) {
        return numeral(tooltipItem.value).format("+0,0");
      },
    },
  },
  scales: {
    xAxes: [
      {
        type: "time",
        time: {
          format: "MM/DD/YY",
          tooltipFormat: "ll",
        },
        ticks: {
          fontColor: "#d6d6d6"
        }
      }
    ],
    yAxes: [
      {
        gridLines: {
          display: false,
        },
        ticks: {
          // Include a dollar sign in the ticks
          callback: function (value, index, values) {
            return numeral(value).format("0a");
          },
          fontColor: "#d6d6d6",
        },
      },
    ],
  },
};

const buildChartData = (data, casesType) => {
  let chartData = [];
  let lastDataPoint;
  for (let date in data.cases) {
    //skipping these dates because incoming data is not accurate and breaks the chart.
    if (lastDataPoint && date !== '12/10/20' && date !== '12/12/20' && date !== '12/14/20') {
      let newDataPoint = {
        x: date,
        y: data[casesType][date] - lastDataPoint,
      };
      chartData.push(newDataPoint);
    }
    lastDataPoint = data[casesType][date];
  }
  return chartData;
};

export default function LineGraph({ casesType = "cases", ...props }) {
  const [data, setData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      await fetch("https://disease.sh/v3/covid-19/historical/all?lastdays=120")
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          let chartData = buildChartData(data, casesType);
          setData(chartData);
        });
    };

    fetchData();
  }, [casesType]);

  const borderColor =  casesType === "cases" ? "rgb(229, 83, 29)" : casesType === "recovered" ? "rgb(40, 122, 40)" : "rgba(209, 54, 54, 0.8)";
  const backgroundColor = casesType === "cases" ? "rgba(229, 83, 29, 0.4)" : casesType === "recovered" ? "rgba(40, 122, 40, 0.4)" : "rgba(209, 54, 54, 0.2)";

  return (
    <div className={props.className}>
      {data?.length > 0 && (
        <Line
          data={{
            datasets: [
              {
                borderColor: borderColor,
                backgroundColor: backgroundColor,
                data: data,
              },
            ],
          }}
          options={options}
        />
      )}
    </div>
  );
}
